// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__tX-7q","content":"Layout_content__y7dUU"};